import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = (u) => setUser(u);

  const refreshUser = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});

  const logout = () => api.post("/auth/logout").catch(() => {}).finally(() => setUser(null));

  // Håndter retur fra Idura BankID-verifisering (query-param ?bankid=verified|error)
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const b = p.get("bankid");
    if (!b) return;
    if (b === "verified") {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
      toast.success("Identitet verifisert med BankID");
    } else if (b === "error") {
      toast.error("BankID-verifisering ble avbrutt eller feilet. Prøv igjen.");
    }
    p.delete("bankid");
    p.delete("reason");
    const qs = p.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
